export default __webpack_public_path__ + "static/media/join-button.6ab290ab.png";